import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';
import { SocketURL } from '../constants/base.url'; // 👈 use this

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket?: Socket;

  connect(token: string) {
    if (this.socket?.connected) return;

    this.socket = io(SocketURL, {
      transports: ['websocket'],
      auth: { token },
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
    });

    this.socket.on('connect', () =>
      console.log('🟢 Socket connected:', this.socket?.id)
    );

    this.socket.on('disconnect', reason =>
      console.log('🔴 Socket disconnected:', reason)
    );

    this.socket.on('connect_error', err =>
      console.log('⚠️ Socket Error:', err?.message || err)
    );
  }

  disconnect() {
    this.socket?.disconnect();
    this.socket = undefined;
  }

  onEvent<T>(event: string): Observable<T> {
    return new Observable<T>((observer) => {

      if (!this.socket) {
        observer.error('Socket not connected');
        return;
      }

      const handler = (data: T) => observer.next(data);

      this.socket.on(event, handler);

      return () => {
        this.socket?.off(event, handler);
      };
    });
  }

  emit(event: string, payload?: any): void {
    if (!this.socket) return;
    this.socket.emit(event, payload);
  }
}
